import { Link } from 'react-router-dom';
import { ArrowRight, KeyRound } from 'lucide-react';
import { Card, CardTitle } from '@/components/ui';

export function ApiKeysPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold">API & Webhooks</h1>
        <p className="mt-0.5 text-sm text-fg-muted">
          API credentials are managed per client. Navigate to a client to rotate keys or
          activate new clients.
        </p>
      </div>

      <Card>
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600 dark:bg-primary-500/15 dark:text-primary-300">
            <KeyRound className="h-5 w-5" />
          </div>
          <div className="flex-1">
            <CardTitle className="mb-1">Client API key management</CardTitle>
            <p className="text-sm text-fg-muted">
              Each client has its own API key issued at activation. To rotate a key or activate a
              new client, go to the Clients section and open the client detail page.
            </p>
            <Link
              to="/clients"
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:underline dark:text-primary-400"
            >
              Go to Clients
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </Card>

      <Card>
        <CardTitle className="mb-3">API authentication reference</CardTitle>
        <div className="space-y-3 text-sm text-fg-muted">
          <p>
            <span className="font-medium text-fg">Customer verification API</span> — requires
            both <code className="rounded bg-surface-subtle px-1 py-0.5 font-mono text-xs">X-API-KEY</code> and{' '}
            <code className="rounded bg-surface-subtle px-1 py-0.5 font-mono text-xs">X-CLIENT-ID</code> headers.
            The raw API key is shown once at activation or key rotation and must be stored securely by the client.
          </p>
          <p>
            <span className="font-medium text-fg">Dashboard API</span> — authenticated via
            Keycloak JWT Bearer token. No API key needed for operator actions.
          </p>
          <p>
            See{' '}
            <Link to="/security" className="text-primary-600 hover:underline dark:text-primary-400">
              Security settings
            </Link>{' '}
            for the current authentication status.
          </p>
        </div>
      </Card>
    </div>
  );
}
